
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  SettingsCardInfo,
  SettingsCardSections,
  SettingsGetters,
  SettingsMutations
} from "@/components/settings/types";
import { Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { scrollToPage } from "@/helpers/utils";
import { UserInfo } from "@/services/apiService/api.types";
import { LocaleSettingsCardsProfile } from "@/plugins/i18n/types";

@Component({})
export default class SettingsCardNew extends Vue {
  @Prop() readonly settingsCardInfo!: SettingsCardInfo;
  @Prop() readonly cardInfoIndex!: number;
  @Prop() readonly cardSection!: SettingsCardSections;

  @Mutation(SettingsMutations.setPinOverlay, { namespace: Namespace.Settings })
  setPinOverlay!: (overlayStatus: boolean) => void;

  @Mutation(SettingsMutations.setActiveCardIndex, {
    namespace: Namespace.Settings
  })
  setActiveCardIndex!: (cardIndex?: number) => void;

  @Mutation(SettingsMutations.setActiveCardSection, {
    namespace: Namespace.Settings
  })
  setActiveCardSection!: (cardSection?: SettingsCardSections) => void;

  @Mutation(SettingsMutations.setUserToEdit, {
    namespace: Namespace.Settings
  })
  setUserToEdit!: (userData?: UserInfo) => void;

  @Getter(SettingsGetters.getEncodedPin, { namespace: Namespace.Settings })
  getEncodedPin!: string;

  @Getter(SettingsGetters.getPinOverlay, { namespace: Namespace.Settings })
  getPinOverlay!: boolean;

  @Getter(SettingsGetters.getActiveCardIndex, { namespace: Namespace.Settings })
  getActiveCardIndex?: number;

  @Getter(SettingsGetters.getActiveCardSection, {
    namespace: Namespace.Settings
  })
  getActiveCardSection?: SettingsCardSections;

  scrollFuncRef = scrollToPage;

  LocaleSettingsCardsProfile = LocaleSettingsCardsProfile;

  get plusIcon(): string {
    return require("/src/assets/svg/svg-settings/14-add-new-profile.svg");
  }

  mounted(): void {
    this.refocusCard();
  }

  handleCardControls(event: KeyboardEvent): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_ENTER:
        this.setActiveCardIndex(this.cardInfoIndex);
        this.setActiveCardSection(this.cardSection);
        this.openPage();
        break;
      case KeySet.KEY_RIGHT:
        SpatialNavigation.resume();
        break;
      case KeySet.KEY_LEFT:
        SpatialNavigation.resume();
        break;
      case KeySet.KEY_BACK:
        SpatialNavigation.resume();
        break;
      default:
        SpatialNavigation.resume();
        break;
    }
  }

  //setting proper section and card id for focusing after closing overlays or returning form a sub page
  openPage(): void {
    if (
      this.getActiveCardIndex === this.cardInfoIndex &&
      this.getActiveCardSection === this.cardSection
    ) {
      if (this.settingsCardInfo.requiresPin && this.getEncodedPin === "") {
        this.setPinOverlay(true);
        return;
      }
      if (this.settingsCardInfo.attachedRoute) {
        this.$router.push({ name: this.settingsCardInfo.attachedRoute });
      }
    }
  }

  refocusCard(): void {
    if (
      this.getActiveCardIndex === this.cardInfoIndex &&
      this.getActiveCardSection === this.cardSection
    ) {
      SpatialNavigation.focus("#" + this.cardSection + this.cardInfoIndex);
      this.setActiveCardIndex();
      this.setActiveCardSection();
    }
  }

  @Watch("getEncodedPin")
  handlePinValidation(newVal: string): void {
    if (newVal !== "") {
      this.openPage();
    }
  }

  @Watch("getPinOverlay")
  handlePinOverlayClose(newVal: boolean): void {
    if (!newVal) {
      this.refocusCard();
    }
  }
}
